import React from "react"
import {NewsLayout} from "sections/News/"
import useNewsData from "shared/Hooks/News/useNewsData"
import {TextBlock} from "src/sections/News/NewsLayout/TextBlock";
import {NEWS_39} from "types/News"
import {Video} from '../../sections/News/NewsLayout/Video/video';
import {Images} from "../../sections/News/NewsLayout/Images";

const Article = () => {
    const data = useNewsData(NEWS_39);

    return (
        <NewsLayout data={data}>
            <Video data={data.videos.first}/>
            <TextBlock data={data.texts.first}/>
            <TextBlock data={data.texts.second}/>
            <TextBlock data={data.texts.third}/>
        </NewsLayout>
    )
}

export default Article;
